import { useDispatch } from 'react-redux'

import { SuccessIcon, FailedIcon, Close } from 'app/components/icons'

import { removeMessage } from 'app/redux/messages/messages.actions'
import styles from './styles.module.scss'
import clsx from 'clsx'

function StatusCard({ cardType, text, teamId, createdAt, msgType, withCloseBtn = false }) {
  const dispatch = useDispatch()
  const handleCloseBtnClick = () => {
    const createdAtTimeStamp = new Date(createdAt).valueOf()
    dispatch(removeMessage({ teamId, createdAt: createdAtTimeStamp, msgType }))
  }

  const cardDetailsByType = {
    success: {
      icon: SuccessIcon,
      color: 'rgba(7, 148, 85, 1)',
    },

    failed: {
      icon: FailedIcon,
      color: 'rgba(217, 45, 32, 1)',
    },
  }

  const Icon = cardDetailsByType[cardType]?.icon
  const color = cardDetailsByType[cardType]?.color

  return (
    <div data-type={cardType} className={clsx(styles.status_card, withCloseBtn && styles.with_close_btn)}>
      {/* header */}
      <div className={styles.status_card__header}>
        {withCloseBtn && (
          <button className={styles.status_card__close_btn} onClick={handleCloseBtnClick}>
            <Close className={styles.status_card__close_icon} />
          </button>
        )}
        <Icon color={color} className={styles.status_card__icon} />
      </div>
      <div className={styles.status_card__text}>{text}</div>
    </div>
  )
}

export default StatusCard
